import { Box, Divider, Grid, Paper, Typography } from '@mui/material';

import { SettingItem, SettingsList } from './SettingsList';

interface SettingsTabContentProps {
  title: string;
  description: string;
  settings: SettingItem[];
  selectedSetting: string | null;
  children: React.ReactNode;
}

export const SettingsTabContent = ({
  title,
  description,
  settings,
  selectedSetting,
  children,
}: SettingsTabContentProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: 3,
      }}
    >
      {/* Header section */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body1" fontWeight="bold" sx={{ mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Box>

      {/* Content section with two boxes */}
      <Grid container sx={{ flexGrow: 1 }}>
        <Grid item xs={12} md={3}>
          <Paper variant="outlined" sx={{ borderRadius: '6px' }}>
            <SettingsList
              settings={settings}
              selectedSetting={selectedSetting}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={9} sx={{ position: 'relative' }}>
          <Divider
            orientation="vertical"
            sx={{
              position: 'absolute',
              left: '10.5px',
              top: 0,
              height: '100%',
              zIndex: 1,
            }}
          />
          <Box
            sx={{
              height: '100%',
              ml: '22px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {children}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
